export default "assets/images/icons/slider-arrow-9eb8a784.svg";